import TemplateOriginal, { meta as metaOriginal, tema as temaOriginal } from "./TemplateOriginal";
import TemplateUniversal, { PALETTES } from "./TemplateUniversal";

// ─── Metadados de exibição (lista de templates) ───────────────────────────────

const METAS = {
  minimalista: { id: "minimalista", label: "Minimalista",     emoji: "🤍", desc: "Branco, limpo e elegante"          },
  elegante:    { id: "elegante",    label: "Elegante",         emoji: "✨", desc: "Fundo escuro, detalhes dourados"   },
  moderno:     { id: "moderno",     label: "Moderno",          emoji: "💜", desc: "Roxo intenso, visual bold"         },
  festivo:     { id: "festivo",     label: "Festivo",          emoji: "🎉", desc: "Colorido e animado"                },
  monica:      { id: "monica",      label: "Turma da Mônica",  emoji: "🐰", desc: "Rosa e amarelo pastel, clássico"   },
  frozen:      { id: "frozen",      label: "Frozen",           emoji: "❄️", desc: "Azul gelado, mágico e elegante"    },
  stitch:      { id: "stitch",      label: "Stitch",           emoji: "🌺", desc: "Azul tropical, Hawaii e divertido" },
  churrasco:   { id: "churrasco",   label: "Churrasco",        emoji: "🔥", desc: "Tons de brasa, festa ao ar livre"  },
};

// ─── Temas do formulário RSVP (usados em RsvpForm para estilização) ───────────

const TEMAS_MAP = {
  minimalista: {
    sectionBg:   "#f5f5f5",
    recadoBg:    "#f0f0f0",
    titulo:      { color: "#111", textShadow: "none" },
    btnAdd:      { background: "#111", color: "white", borderRadius: 4 },
    itemBg:      "white",
    numeroBg:    "#333",
    numeroColor: "white",
    labelColor:  "#444",
    inputExtra:  { borderColor: "#ccc" },
    submit:      { background: "#111", boxShadow: "0 5px 15px rgba(0,0,0,0.15)", borderRadius: 4, letterSpacing: "0.5px" },
  },
  elegante: {
    sectionBg:   "rgba(255,255,255,0.06)",
    recadoBg:    "rgba(255,255,255,0.04)",
    titulo:      { color: "#c9a84c", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#c9a84c,#b8923a)", color: "#1a1a1a" },
    itemBg:      "#252525",
    numeroBg:    "#c9a84c",
    numeroColor: "#1a1a1a",
    labelColor:  "#c9a84c",
    inputExtra:  { background: "#2a2a2a", borderColor: "#3a3a3a", color: "#f5f0e8" },
    submit:      { background: "linear-gradient(45deg,#c9a84c,#b8923a)", boxShadow: "0 5px 15px rgba(201,168,76,0.35)", color: "#1a1a1a", borderRadius: 4 },
  },
  moderno: {
    sectionBg:   "#eef2ff",
    recadoBg:    "#e8edff",
    titulo:      { color: "#4f46e5", textShadow: "none" },
    btnAdd:      { background: "#4f46e5", color: "white" },
    itemBg:      "white",
    numeroBg:    "#4f46e5",
    numeroColor: "white",
    labelColor:  "#4f46e5",
    inputExtra:  { borderColor: "#c7d2fe" },
    submit:      { background: "linear-gradient(45deg,#4f46e5,#3730a3)", boxShadow: "0 5px 15px rgba(79,70,229,0.4)", borderRadius: 25 },
  },
  festivo: {
    sectionBg:   "rgba(255,107,107,0.08)",
    recadoBg:    "rgba(107,207,127,0.1)",
    titulo:      { color: "#c0392b", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#ff6b6b,#ffd93d)", color: "white" },
    itemBg:      "#fffdf5",
    numeroBg:    "#ff6b6b",
    numeroColor: "white",
    labelColor:  "#555",
    inputExtra:  {},
    submit:      { background: "linear-gradient(135deg,#ff6b6b,#ffd93d)", boxShadow: "0 5px 15px rgba(255,107,107,0.4)", borderRadius: 25 },
  },
  monica: {
    sectionBg:   "rgba(244,144,154,0.1)",
    recadoBg:    "rgba(253,230,138,0.3)",
    titulo:      { color: "#c97b84", textShadow: "none" },
    btnAdd:      { background: "#f4909a", color: "white" },
    itemBg:      "white",
    numeroBg:    "#fde68a",
    numeroColor: "#7c2d12",
    labelColor:  "#7c2d12",
    inputExtra:  { borderColor: "#fde68a" },
    submit:      { background: "linear-gradient(45deg,#f4909a,#e07880)", boxShadow: "0 5px 15px rgba(244,144,154,0.4)", borderRadius: 25 },
  },
  frozen: {
    sectionBg:   "rgba(74,154,186,0.1)",
    recadoBg:    "rgba(202,240,248,0.35)",
    titulo:      { color: "#1b4965", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#1b4965,#4a9aba)", color: "white" },
    itemBg:      "rgba(202,240,248,0.18)",
    numeroBg:    "#4a9aba",
    numeroColor: "white",
    labelColor:  "#1b4965",
    inputExtra:  { borderColor: "#90e0ef" },
    submit:      { background: "linear-gradient(45deg,#1b4965,#4a9aba)", boxShadow: "0 5px 15px rgba(27,73,101,0.35)", borderRadius: 4 },
  },
  stitch: {
    sectionBg:   "rgba(0,150,199,0.08)",
    recadoBg:    "rgba(144,224,239,0.2)",
    titulo:      { color: "#0077b6", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#0077b6,#00b4d8)", color: "white" },
    itemBg:      "rgba(202,240,248,0.2)",
    numeroBg:    "#0096c7",
    numeroColor: "white",
    labelColor:  "#023e8a",
    inputExtra:  { borderColor: "#90e0ef" },
    submit:      { background: "linear-gradient(45deg,#023e8a,#0077b6)", boxShadow: "0 5px 15px rgba(2,62,138,0.4)", borderRadius: 25 },
  },
  churrasco: {
    sectionBg:   "rgba(249,115,22,0.08)",
    recadoBg:    "rgba(217,119,6,0.1)",
    titulo:      { color: "#c2410c", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#ea580c,#c2410c)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#ea580c",
    numeroColor: "white",
    labelColor:  "#7c2d12",
    inputExtra:  { borderColor: "#fed7aa" },
    submit:      { background: "linear-gradient(45deg,#c2410c,#9a3412)", boxShadow: "0 5px 15px rgba(194,65,12,0.4)", borderRadius: 8 },
  },
};

// ─── IDs que usam TemplateUniversal ───────────────────────────────────────────

const UNIVERSAL_IDS = Object.keys(METAS);

// ─── Exports públicos ─────────────────────────────────────────────────────────

/** Map id → componente React  (usado em EventoPublico para renderizar) */
export const TEMPLATES = {
  original: TemplateOriginal,
  ...Object.fromEntries(UNIVERSAL_IDS.map(id => [id, TemplateUniversal])),
};

/** Map id → objeto de tema     (usado em RsvpForm para estilização) */
export const TEMAS = {
  original: temaOriginal,
  ...TEMAS_MAP,
};

/** Array de metadados ordenado (usado em EventoForm para listar opções) */
export const TEMPLATES_LIST = [
  metaOriginal,
  ...UNIVERSAL_IDS.map(id => METAS[id]),
];

/** Palettes de cada tema universal (usado em LayoutsManager) */
export { PALETTES };
